import clsx from "clsx"
import { useContext, useEffect, useState } from "react"
import { MediaMobile } from "../../../../api/const/MediaQuery"
import useMediaQuery from "../../../../hook/useMediaQuery"
import { AppGeneralContext } from "../../../../shared/GeneralContext/GeneralContext"
import { Button } from "../../../atoms"
import { MatchDate } from "../../../types/types"
import { DatesForm } from "./DatesForm"
import { StepperDatesHeader } from "./StepperDatesHeader"

export const SelectThirdDate = (props:any)=>{
  
    const { matchCallDates, setMatchCallDates, resetMatchCallDates,setModalDatesIsOpen } = useContext(AppGeneralContext)
    const [date, setDate] = useState<string | Date>()
    const [isDisabled,setIsDisabled] = useState<boolean>(true)
    const mobile = useMediaQuery(MediaMobile)
    const [errorMessage, setErrorMessage] = useState("")

    const getDate = (finalDate: string | Date | undefined) => {
        setDate(finalDate);
        setIsDisabled(false)
    }

    const cancel = ()=>{
        resetMatchCallDates();
        props.goToStep(1);
        setModalDatesIsOpen(false);
    }

    useEffect(()=>{
        if(date && errorMessage) {
            const date1 = new Date(matchCallDates?.[0].date as any)
            const date2 = new Date(matchCallDates?.[1].date as any)
            const date3 = new Date(date)

            if(date1.toISOString() === date3.toISOString()){
                setErrorMessage("Date already selected")
                return
            }

            if(date2.toISOString() === date3.toISOString()){
                setErrorMessage("Date already selected")
                return
            }
            setErrorMessage("")
        }

    },[date, errorMessage, matchCallDates])

    const save = () => {
        if (date) {

            let thirdDate: MatchDate[] = [{
                id: "thirdDate",
                date: date
            }]

            const date1 = new Date(matchCallDates?.[0].date as any)
            const date2 = new Date(matchCallDates?.[1].date as any)
            const date3 = new Date(date)

            if(date1.toISOString() === date3.toISOString()){
                setErrorMessage("Date already selected")
                return
            }

            if(date2.toISOString() === date3.toISOString()){
                setErrorMessage("Date already selected")
                return
            }
             
            if(matchCallDates){
            let firstPlusSeconDate = matchCallDates.concat(thirdDate)
            setMatchCallDates(firstPlusSeconDate)
            props.nextStep()
            }
        }
    }

    return (
        <div className=" mt-3 position-relative">
              <StepperDatesHeader title={"THIRD DATE"}/>
              <div className="d-flex flex-column justify-content-between">
                <DatesForm getValue={(date)=>getDate(date)}/>
                {errorMessage && <div className="text-error w-100 text-center fw-600 mt-2">{errorMessage}</div>}
                <div className={clsx("d-flex pt-4  ",
                {"justify-content-end flex-row" : !mobile} ,
                {"justify-content-center align-items-center flex-column-reverse mb-5" : mobile})}>
                <Button  primary text={"CANCEL"} background={"transparent"}
                    color={"black"} borderColor={"var(--black)"}
                    className={clsx("",
                    { "me-4": !mobile},
                    { "mt-2": mobile} )}
                    onClick={() => cancel()} />
                    <Button disabled={isDisabled}  primary text={"RESUME"} background={"var(--primary)"}
                     color={"white"} borderColor={"var(--primary)"}
                     onClick={()=>save()}/>
                </div>
              </div>
        </div>
    )

}